export var ServiceOrderStatus;
(function (ServiceOrderStatus) {
    ServiceOrderStatus["ReadyForPayment"] = "Ready for Payment";
    ServiceOrderStatus["Failed"] = "Failed";
    ServiceOrderStatus["Expired"] = "Expired";
    ServiceOrderStatus["Processing"] = "Processing";
    ServiceOrderStatus["Completed"] = "Completed";
})(ServiceOrderStatus || (ServiceOrderStatus = {}));
